// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__12G9k","select":"Header_select__1b5Qo","clinic":"Header_clinic__1fFTt"};